// apps/share-web/src/offline/library-sync.ts
//
// Что сделать с кэшем, когда вернулся ответ /api/library. Ответ успешен —
// переписать снимок и свериться с ним; во ВСЕХ остальных случаях кэш не
// трогается ничем. В этом весь смысл модуля.
//
// ⚠️ ГЛАВНЫЙ ЗАМОК ВОЛНЫ ЖИВЁТ ЗДЕСЬ. Сетевой отказ обязан приводить к `keep`:
// кэш не трогаем ничем. Соблазн «раз списка нет, значит и в кэше ничего не
// должно быть» стёр бы библиотеку при первом же провале сети — и человек
// открыл бы служение с пустым экраном, то есть получил бы ровно тот отказ,
// против которого волна затевалась.
//
// 401 ТОЖЕ приводит к `keep`, и это решение владельца продукта: «приоритет,
// чтобы у нас всегда был кеш; то, что оно может когда-то не удалиться — не
// так важно». Один 401 от прокси или при сбое туннеля посреди служения стёр
// бы офлайн-библиотеку целиком — тот же пустой экран, против которого волна
// затевается. Дыры здесь нет: вход под другим человеком попадает в другое
// хранилище (личность — первая часть ключа), а отозванный доступ снимается
// сверкой при первом же успешном ответе. Источник `wipe` теперь только
// явный — выход из аккаунта и кнопка «стереть офлайн-данные».
//
// Почему решение вынесено из main.ts. Проверять расположение вызова
// регуляркой по исходнику — ложный замок того класса, который волны E и F
// дали шесть раз подряд: текст зелен, защиты нет. Здесь замок поведенческий,
// и красит его мутация самой логики.

import type { LibraryResult, TeamLibrary } from '../library.js';

export type SyncAction =
  /** Ответ пришёл: переписать снимок и свериться с ним. */
  | { kind: 'save-and-reconcile'; teams: TeamLibrary[]; at: string }
  /** Стереть всё этого человека. Источник у этого исхода ТОЛЬКО явный:
   *  выход из аккаунта и кнопка «стереть офлайн-данные». Ответ сервера —
   *  никакой, включая 401: см. решение в шапке. */
  | { kind: 'wipe' }
  /** Сеть подвела: не трогать кэш ничем. */
  | { kind: 'keep' };

export function syncAction(result: LibraryResult, nowIso: string): SyncAction {
  if (result.ok) return { kind: 'save-and-reconcile', teams: result.teams, at: nowIso };
  // 401 сюда НЕ выделен намеренно: см. «401 тоже keep» в шапке.
  return { kind: 'keep' };
}
